import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Navigation = ({ onLogout, userData }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
      navigate('/');
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-brand" onClick={() => navigate('/')}>
        <span>🧠</span>
        <span>Brain Rot</span>
      </div>

      <div className="nav-links">
        <NavLink 
          to="/" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <span>🏠</span>
          <span>Home</span>
        </NavLink>

        <NavLink 
          to="/activities" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <span>🎯</span>
          <span>Activities</span>
        </NavLink>

        <NavLink 
          to="/profile" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <span>👤</span>
          <span>Profile</span>
        </NavLink>
      </div>

      <div className="user-menu">
        <div className="user-info">
          <div className="user-avatar">
            {userData?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <span>{userData?.name || 'User'}</span>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navigation;